// const rumbleColors = [
// 	{ value: 1, duration: 120, color: '#4a90e2', secondaryColor: '#4382cb', },
// 	{ value: 2, duration: 180, color: '#b8e986', secondaryColor: '#a6d279', },
// 	{ value: 5, duration: 300, color: '#f8e71c', secondaryColor: '#dfd019', },
// 	{ value: 10, duration: 600, color: '#f5a623', secondaryColor: '#dd9520', },
// 	{ value: 20, duration: 1200, color: '#bd10e0', secondaryColor: '#aa0eca', },
// 	{ value: 50, duration: 2400, color: '#9013fe', secondaryColor: '#8211e5', },
// 	{ value: 100, duration: 3600, color: '#d0021b', secondaryColor: '#bb0218', },
// 	{ value: 200, duration: 7200, color: '#d0021b', secondaryColor: '#bb0218', },
// 	{ value: 300, duration: 10800, color: '#d0021b', secondaryColor: '#bb0218', },
// 	{ value: 400, duration: 14400, color: '#d0021b', secondaryColor: '#bb0218', },
// 	{ value: 500, duration: 18000, color: '#d0021b', secondaryColor: '#bb0218', },
// ];

const youtubeColors = [
	{ value:   1, duration:          30, color: '#1e88e5', colorName: 'Blue',       secondaryColor: '#1565c0', textColor: '#FFFFFF', },
	{ value:   2, duration:      1 * 60, color: '#00e5ff', colorName: 'Light blue', secondaryColor: '#00b8d4', textColor: '#000000', },
	{ value:   5, duration:      2 * 60, color: '#1de9b6', colorName: 'Green',      secondaryColor: '#00bfa5', textColor: '#000000', },
	{ value:  10, duration:      5 * 60, color: '#ffca28', colorName: 'Yellow',     secondaryColor: '#ffb300', textColor: '#000000', },
	{ value:  20, duration:     10 * 60, color: '#f57c00', colorName: 'Orange',     secondaryColor: '#e65100', textColor: '#FFFFFF', },
	{ value:  50, duration:     30 * 60, color: '#e91e63', colorName: 'Magenta',    secondaryColor: '#c2185b', textColor: '#FFFFFF', },
	{ value: 100, duration: 1 * 60 * 60, color: '#e62117', colorName: 'Red',        secondaryColor: '#d00000', textColor: '#FFFFFF', },
	{ value: 200, duration: 2 * 60 * 60, color: '#e62117', colorName: 'Red',        secondaryColor: '#D00000', textColor: '#FFFFFF', },
	{ value: 300, duration: 3 * 60 * 60, color: '#e62117', colorName: 'Red',        secondaryColor: '#D00000', textColor: '#FFFFFF', },
	{ value: 400, duration: 4 * 60 * 60, color: '#e62117', colorName: 'Red',        secondaryColor: '#D00000', textColor: '#FFFFFF', },
	{ value: 500, duration: 5 * 60 * 60, color: '#e62117', colorName: 'Red',        secondaryColor: '#D00000', textColor: '#FFFFFF', },
];

export default youtubeColors;
